import { render, staticRenderFns } from "./InputTextarea.vue?vue&type=template&id=1e56ae2c&scoped=true&"
import script from "./InputTextarea.vue?vue&type=script&lang=js&"
export * from "./InputTextarea.vue?vue&type=script&lang=js&"
import style0 from "@/sass/07_elements/input-textarea.scss?vue&type=style&index=0&id=1e56ae2c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e56ae2c",
  null
  
)

export default component.exports